"use client";

import { BackendButton } from "@/app/components/backend/backend-ui";
import { Loader2 } from "lucide-react";
import { useFormStatus } from "react-dom";

export function LoginButton() {
  const { pending } = useFormStatus();

  return (
    <BackendButton
      type="submit"
      disabled={pending}
      className="mt-6 h-12 w-full text-[15px]"
    >
      {pending && <Loader2 className="h-4 w-4 animate-spin" />}
      <span>Anmelden</span>
    </BackendButton>
  );
}
